import React from 'react';
import ExpenseObligationWorkspace from './ExpenseObligationWorkspace';

/** 원인행위승인 */
export default function ExpenseObligationApprove() {
  return <ExpenseObligationWorkspace screenMode="approve" />;
}
